import moment from 'moment';
import { useTranslation } from 'react-i18next';

import {
  Icon,
  ICONS,
  PLATFORM_THEME_COLORS,
  Table,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';

import { DocumentFilesList } from 'src/components/document-files-list';

import { StyledTable } from './documents-list-table.styles';

const DocumentsListTable = ({
  data,
  documentId,
  employeeId,
  isOwnData
}: {
  data: any;
  documentId: string;
  employeeId: string;
  isOwnData?: boolean
}) => {
  const { t } = useTranslation(['common', 'employee']);

  return (
    <StyledTable dataSource={data} rowKey={record => record._id}>
      <Table.Column
        title={t('employee:labels.documentName')}
        dataIndex="title"
        key="title"
        render={title => (
          <div>
            <Icon icon={ICONS.file} size={16} color={PLATFORM_THEME_COLORS.primary.grey} />
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>{title}</Typography>
          </div>
        )}
      />
      <Table.Column
        title={t('employee:labels.uploading')}
        dataIndex="createdAt"
        key="createdAt"
        render={createdAt => (
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {moment(createdAt).format('DD.MM.YYYY; HH:mm')}
          </Typography>
        )}
      />
      <Table.Column
        title={t('common:labels.description')}
        dataIndex="description"
        key="description"
        render={description => (
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {description || '-'}
          </Typography>
        )}
      />
      <Table.Column
        title={t('common:labels.action')}
        width={50}
        render={record => (
          <DocumentFilesList isOwnData={isOwnData} template={record} documentId={documentId} employeeId={employeeId} />
        )}
      />
    </StyledTable>
  );
};

export default DocumentsListTable;
